import { render, staticRenderFns } from "./ModalVideoYouTube.vue?vue&type=template&id=50d03d26&scoped=true"
import script from "./ModalVideoYouTube.vue?vue&type=script&lang=js"
export * from "./ModalVideoYouTube.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d03d26",
  null
  
)

export default component.exports